import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/all-img/c1.png'
import _imports_1 from '../../assets/img/all-img/c2.png'
import _imports_2 from '../../assets/img/all-img/c3.png'
import _imports_3 from '../../assets/img/all-img/c4.png'
import _imports_4 from '../../assets/img/all-img/c5.png'
import _imports_5 from '../../assets/img/all-img/c6.png'


const _hoisted_1 = { class: "edu-courses-area pt-70 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "edu-grid-sorting" }
const _hoisted_7 = { class: "row align-items-center" }
const _hoisted_8 = { class: "col-lg-8 col-md-6 result-count" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-grid-alt" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-list-ul" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Showing 12 Courses of 52", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-6 ordering" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "select-box" }, [
    /*#__PURE__*/_createElementVNode("label"),
    /*#__PURE__*/_createElementVNode("select", null, [
      /*#__PURE__*/_createElementVNode("option", null, "Popularity"),
      /*#__PURE__*/_createElementVNode("option", null, "A-Z"),
      /*#__PURE__*/_createElementVNode("option", null, "Cheapest"),
      /*#__PURE__*/_createElementVNode("option", null, "Most Expensive")
    ])
  ])
], -1)
const _hoisted_13 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_14 = { class: "single-courses-box" }
const _hoisted_15 = { class: "image" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Development")
  ])
], -1)
const _hoisted_18 = { class: "content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$12.77", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "4.2")
  ])
], -1)
const _hoisted_21 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_22 = { class: "single-courses-box" }
const _hoisted_23 = { class: "image" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "image"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Art & Design ")
  ])
], -1)
const _hoisted_26 = { class: "content" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$18.27", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "5")
  ])
], -1)
const _hoisted_29 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_30 = { class: "single-courses-box" }
const _hoisted_31 = { class: "image" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "image"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Art & Design ")
  ])
], -1)
const _hoisted_34 = { class: "content" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$20.07", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "2.5")
  ])
], -1)
const _hoisted_37 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_38 = { class: "single-courses-box" }
const _hoisted_39 = { class: "image" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "image"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Art & Design ")
  ])
], -1)
const _hoisted_42 = { class: "content" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$19", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "4.5")
  ])
], -1)
const _hoisted_45 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_46 = { class: "single-courses-box" }
const _hoisted_47 = { class: "image" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "image"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Drawing")
  ])
], -1)
const _hoisted_50 = { class: "content" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$40.23", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "3.5")
  ])
], -1)
const _hoisted_53 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_54 = { class: "single-courses-box" }
const _hoisted_55 = { class: "image" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "image"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Drawing")
  ])
], -1)
const _hoisted_58 = { class: "content" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$21.50", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "1.5")
  ])
], -1)
const _hoisted_61 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_62 = { class: "single-courses-box" }
const _hoisted_63 = { class: "image" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "image"
}, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Technology")
  ])
], -1)
const _hoisted_66 = { class: "content" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$89", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "1.5")
  ])
], -1)
const _hoisted_69 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_70 = { class: "single-courses-box" }
const _hoisted_71 = { class: "image" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "image"
}, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Data Science")
  ])
], -1)
const _hoisted_74 = { class: "content" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "cr-price" }, "$50.55", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "2.5")
  ])
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "section-button" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "default-btn"
  }, [
    /*#__PURE__*/_createTextVNode(" Load More "),
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-revision" })
  ])
], -1)
const _hoisted_78 = { class: "col-lg-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CoursesSidebar = _resolveComponent("CoursesSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/courses-sidebar",
                    class: "courbtn active-courbtn"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/courses-list",
                    class: "courbtn"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _hoisted_11
                ]),
                _hoisted_12
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Your Path to Financial Success ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_20
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }),
                  _hoisted_25
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Basic Fundamentals of Interior & Graphics Design ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_28
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }),
                  _hoisted_33
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Increasing Engagement with Instagram & Facebook ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_36
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40
                    ]),
                    _: 1
                  }),
                  _hoisted_41
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Increasing Engagement with Instagram & Facebook ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_44
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  }),
                  _hoisted_49
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Introduction to Color Theory & Basic UI/UX ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_52
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56
                    ]),
                    _: 1
                  }),
                  _hoisted_57
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Introduction to Color Theory & Basic UI/UX ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_60
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_64
                    ]),
                    _: 1
                  }),
                  _hoisted_65
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Financial Security Thinking and Principles Theory ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_68
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_router_link, {
                    to: "/courses-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72
                    ]),
                    _: 1
                  }),
                  _hoisted_73
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/courses-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Free Logo Design: From Concept to Presentation ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_76
                ])
              ])
            ]),
            _hoisted_77
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _createVNode(_component_CoursesSidebar)
        ])
      ])
    ])
  ]))
}